import React, { useMemo, useEffect, useRef, useState, useCallback } from 'react';
import AdTable from './components/AdsTable.js';
import { useTableState } from './utils/useTableState.js';
import FilterBar from './components/FilterBar.js';
import { CSVLink } from "react-csv";
import { Toast } from "../../shared/Toast.js";
import { alphaformatDateTime } from "../../utils/dateFormat.js";
import { LINE_ITEM_STATUS } from "./utils/useTableState.js";
import { usePersistedFilterState } from './utils/usePersistedFilterState.js';
const types = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "full_page",
    label: "Full Image",
  },
  {
    value: "full_video",
    label: "Full Video",
  },
  {
      value:"half_video",
      label:"Half Video"
  },
  {
    value: "promoted_image_story",
    label: "Promoted Image Story ",
  },
  {
    value:"promoted_video_story",
    label:"Promoted Video Story"
  },
  {
    value: "classifiedads",
    label: "Classified Ads"
  }
]
const STATUS_OPTIONS = [
  { value:-1, label: 'Pending Request'},
  { value: 2, label: 'Saved' },
  { value: 3, label: 'Picked' },
  { value: 4, label: 'Completed' },
  { value: 5, label: 'Rejected' },
  { value: 6, label: 'Accepted' },
  { value: 7, label: 'Payment Completed'},
  { value: 8, label: 'Order, LineItem Created'}
];

const AllAds = ({ isActive }) => {
    const allAdsColumns = [
        { key: "sno" , label : "S.No"},
        { key: "sales_person", label: "Sales Person Details" },
        { key: "cst_name", label: "CST Name" },
        { key: "designer_name", label: "Designer Name" },
        { key: "created_at", label: "Ad Creation Date" },
        // { key: "brand_name", label: "Brand" },
        // { key: "client_name", label: "Client" },
        { key: "creative_name", label: "Campaign Name" },
        // { key: "creative_start_date", label: "Start Date" },
        // { key: "creative_end_date", label: "End Date" },
        { key: "ad_creative_sub_type", label: "Ad Type" },
        // { key: "type", label: "Creative Type" },
        { key: "client_mobile", label: "Mobile" },
        { key: "order_details", label: "Order Details" },
        { key: "location_details", label: "Location Details"},
        { key: "content", label:"Content"},
        { key: "status", label: "Design Status" },
        { key: "live_item_status", label: "Line Item Status"},
        { key: "live_status", label: "Live" },
        { key: "action", label: "Action" },
    ];
    const {
        fetchAllAds,
        fetchAllAdsForCsv,
        currentPage,
        setCurrentPage,
        setAdsData,
        adsData,
        hasMore,
        designers,
        fetchDesigners,
        loading,
        totalRecords,
        showActionsMenu,
        modal,
        drawer,
        expandedVersionsRow,
        actionHandlers,
        renderCell,
        getModalAlt,
        closeExpandedRows,
        handleDesignerChange,
        handleGoToLive,
        fetchContent,
        salesList,
        getSalesList,
        fetchSalesLocations,
        salesLocations,
    } = useTableState();

    // const today = new Date().toISOString().split('T')[0];
    // const tomorrow = new Date();
    // tomorrow.setDate(tomorrow.getDate() + 1);
    // const tomorrowStr = tomorrow.toISOString().split('T')[0];
    const [dateRange, setDateRange] = usePersistedFilterState('alpha_designer.all_ads.dateRange', { startDate: null, endDate: null });
    const [designer, setDesigner] = usePersistedFilterState('alpha_designer.all_ads.designer', null);
    const [status, setStatus] = usePersistedFilterState('alpha_designer.all_ads.status', null);
    const [adType, setAdType] = usePersistedFilterState('alpha_designer.all_ads.adType', null);
    const [search, setSearch] = usePersistedFilterState('alpha_designer.all_ads.search', '');
    const [salesPerson, setSalesPerson] = usePersistedFilterState('alpha_designer.all_ads.salesPerson', null);
    const [salesLocation, setSalesLocation] = usePersistedFilterState('alpha_designer.all_ads.salesLocation', []);
    const [lineItemStatus, setLineItemStatus] = usePersistedFilterState('alpha_designer.all_ads.lineItemStatus', null);
    const [sortByLatestMessage, setSortByLatestMessage] = usePersistedFilterState('view_alpha_by_latest_message', false);
    const csvLinkRef = useRef(null);
    const [csvExportData, setCsvExportData] = useState([]);
    const [csvExporting, setCsvExporting] = useState(false);
    const designerOptions = useMemo(() =>
        designers.map(d => ({ value: d.designer_id, label: d.name })),
        [designers]
    )
    

    useEffect(() => {
        fetchDesigners();
        getSalesList();
        fetchSalesLocations();
    }, []);

    const loadMoreCtx = useRef({});
    loadMoreCtx.current = { loading, hasMore, currentPage, isActive, dateRange, designer, status, adType, search, salesPerson, salesLocation, lineItemStatus, sortByLatestMessage };

    // Reset and fetch on filter/tab change
    useEffect(() => {
        setCurrentPage(0);
        setAdsData([]);
        fetchAllAds(0, isActive, {
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
            designerId: designer ? designer.value : undefined,
            status: status ? status.value : undefined,
            adType: adType && adType.value !== 'all' ? adType.value : undefined,
            search: search || undefined,
            sales_person_id: salesPerson?.value ? [salesPerson.value] : null,
            sales_location: salesLocation?.length ? salesLocation.map((o) => o.value) : null,
            line_item_status: lineItemStatus?.value || null,
            sort_by_latest_message: sortByLatestMessage,
        }, false);
    }, [isActive, dateRange, designer, status, adType, search, salesPerson, salesLocation, lineItemStatus, sortByLatestMessage]);

    // On-demand re-fetch of the current filters/page, separate from the auto
    // fetch on filter/tab change or pagination.
    const handleRefresh = useCallback(() => {
        setCurrentPage(0);
        setAdsData([]);
        fetchAllAds(0, isActive, {
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
            designerId: designer ? designer.value : undefined,
            status: status ? status.value : undefined,
            adType: adType && adType.value !== 'all' ? adType.value : undefined,
            search: search || undefined,
            sales_person_id: salesPerson?.value ? [salesPerson.value] : null,
            sales_location: salesLocation?.length ? salesLocation.map((o) => o.value) : null,
            line_item_status: lineItemStatus?.value || null,
            sort_by_latest_message: sortByLatestMessage,
        }, false);
    }, [fetchAllAds, isActive, dateRange, designer, status, adType, search, salesPerson, salesLocation, lineItemStatus, sortByLatestMessage]);

    const handleLoadMore = useCallback(() => {
        const ctx = loadMoreCtx.current;
        if (ctx.loading || !ctx.hasMore) return;
        const nextPage = ctx.currentPage + 1;
        setCurrentPage(nextPage);
        fetchAllAds(nextPage, ctx.isActive, {
            startDate: ctx.dateRange.startDate,
            endDate: ctx.dateRange.endDate,
            designerId: ctx.designer ? ctx.designer.value : undefined,
            status: ctx.status ? ctx.status.value : undefined,
            adType: ctx.adType && ctx.adType.value !== 'all' ? ctx.adType.value : undefined,
            search: ctx.search || undefined,
            sales_person_id: ctx.salesPerson?.value ? [ctx.salesPerson.value] : null,
            sales_location: ctx.salesLocation?.length ? ctx.salesLocation.map((o) => o.value) : null,
            line_item_status: ctx.lineItemStatus?.value || null,
            sort_by_latest_message: ctx.sortByLatestMessage,
        }, true);
    }, [fetchAllAds]);

    const handleDateChange = (val) => setDateRange(val);
    const handleDesignerChangeSelect = (val) => setDesigner(val);
    const handleStatusChange = (val) => setStatus(val);
    const handleAdTypeChange = (val) => setAdType(val);
    const handleSearchChange = (value) => setSearch(value);
    const handleSalesPersonChange = (value) => setSalesPerson(value);
    const handleSalesLocationChange = (value) => setSalesLocation(value);
    const handleLineItemStatusChange = (value) => setLineItemStatus(value);
    const handleSortByLatestMessageChange = (value) => setSortByLatestMessage(value);
    const processedData = useMemo(() => {
        return adsData.map(ad => ({
            ...ad,
            live_status: ad.paymentStatus === 'Done' ? 'Live' : 'Pending'
        }));
    }, [adsData]);

    const csvHeaders = useMemo(() => ([
        { label: "Sales Person Details", key: "sales_person_details" },
        { label: "CST Name", key: "cst_name" },
        { label: "Designer Name", key: "designer_name" },
        { label: "Ad Creation Date", key: "ad_creation_date" },
        { label: "Campaign Name", key: "campaign_name" },
        { label: "Ad Type", key: "ad_type" },
        { label: "Mobile", key: "mobile" },
        { label: "Order Details", key: "order_details" },
        { label: "Location Details", key: "location_details" },
        { label: "Design Status", key: "design_status" },
        { label: "Line Item Status", key: "line_item_status" },
        { label: "Live", key: "live" },
        // Extra fields requested
        { label: "Order Value", key: "order_value" },
        { label: "Discount Value", key: "discount_value" },
        { label: "Discount Amount", key: "discount_amount" },
    ]), []);

    const safeText = (val, fallback = "-") => {
        if (val === null || val === undefined) return fallback;
        const str = String(val).trim();
        return str.length ? str : fallback;
    };

    const formatDateTimeText = (timestamp) => {
        try {
            const { dateStr, timeStr } = alphaformatDateTime(timestamp);
            const out = `${dateStr} ${timeStr}`.trim();
            return out === "-" || out === "- -" ? "-" : out;
        } catch (e) {
            return "-";
        }
    };

    const getDesignStatusLabel = (statusCode) => {
        switch (statusCode) {
            case -1: return "Pending Request";
            case 1: return "Draft";
            case 2: return "Saved";
            case 3: return "Picked";
            case 4: return "Completed";
            case 5: return "Rejected";
            case 6: return "Accepted";
            case 7: return "Payment Success";
            case 8: return "Order Created";
            case 9: return "Completed";
            default: return "Unknown";
        }
    };

    const getLineItemStatusLabel = (lineItemStatus) => {
        try {
            const item = LINE_ITEM_STATUS?.find((x) => x?.value === lineItemStatus);
            return safeText(item?.label, "-");
        } catch (e) {
            return "-";
        }
    };

    const getLocationDetailsText = (row) => {
        const dist = row?.sales_person?.dist_name;
        return dist ? `${dist} (D)` : "-";
    };

    const getSalesPersonDetailsText = (row) => {
        try {
            const name = safeText(row?.sales_person?.sales_person_name, "-");
            const mobile = safeText(row?.sales_person?.mobile, "-");
            const start = formatDateTimeText(row?.creative_start_date);
            const { dateStr: endDateStr, timeStr: endTimeStr } = alphaformatDateTime(row?.creative_start_date, "end");
            const end = `${endDateStr} ${endTimeStr}`.trim();
            return `${name} | ${mobile} | ${start} - ${safeText(end, "-")}`;
        } catch (e) {
            return "-";
        }
    };

    const getAdTypeText = (row) => {
        const parts = [row?.type, row?.ad_creative_sub_type].filter(Boolean);
        return safeText(parts.join(" / "), "-");
    };

    const buildCsvRow = (row) => {
        return {
            sales_person_details: getSalesPersonDetailsText(row),
            cst_name: safeText(row?.cst_name, "-"),
            designer_name: safeText(row?.designer_name, "Unassigned"),
            ad_creation_date: formatDateTimeText(row?.created_at),
            campaign_name: safeText(row?.creative_name, "-"),
            ad_type: getAdTypeText(row),
            mobile: safeText(row?.client_mobile, "-"),
            order_details: safeText(row?.order_id ?? (row?.status === 8 ? "Created" : "-"), "-"),
            location_details: getLocationDetailsText(row),
            design_status: getDesignStatusLabel(row?.status),
            line_item_status: getLineItemStatusLabel(row?.line_item_status),
            live: safeText(row?.live_status, "-"),
            order_value: safeText(row?.order_value ?? row?.amount ?? row?.order_details?.order_value, "-"),
            discount_value: safeText(row?.discount, "-"),
            discount_amount: safeText(row?.discount_amount, "-"),
        };
    };

    const handleDownloadCsv = async () => {
        setCsvExporting(true);
        try {
            // Fetch all data for CSV export
            const allDataForCsv = await fetchAllAdsForCsv("/alpha_cst_designer/all-ads", {
                startDate: dateRange.startDate,
                endDate: dateRange.endDate,
                designerId: designer ? designer.value : undefined,
                status: status ? status.value : undefined,
                adType: adType && adType.value !== 'all' ? adType.value : undefined,
                search: search || undefined,
                sales_person_id: salesPerson?.value ? [salesPerson.value] : null,
                sales_location: salesLocation?.length ? salesLocation.map((o) => o.value) : null,
                line_item_status: lineItemStatus?.value || null,
            });

            const rows = Array.isArray(allDataForCsv) ? allDataForCsv : [];
            const built = rows.map((row) => buildCsvRow(row));
            setCsvExportData(built);
            setTimeout(() => {
                csvLinkRef?.current?.link?.click?.();
                setCsvExporting(false);
            }, 0);
        } catch (error) {
            console.error("AllAds CSV export failed:", error);
            Toast("error", "Failed to export CSV");
            setCsvExporting(false);
        }
    };

    return (
        <div>
            <FilterBar
                dateRange={dateRange}
                onDateChange={handleDateChange}
                designer={designer}
                onDesignerChange={handleDesignerChangeSelect}
                designerOptions={designerOptions}
                status={status}
                onStatusChange={handleStatusChange}
                statusOptions={STATUS_OPTIONS}
                adType={adType}
                onAdTypeChange={handleAdTypeChange}
                adTypeOptions={types}
                search={search}
                onSearchChange={handleSearchChange}
                salesPerson={salesPerson}
                onSalesPersonChange={handleSalesPersonChange}
                salesPersonOptions={salesList}
                showSalesPerson={true}
                salesLocation={salesLocation}
                onSalesLocationChange={handleSalesLocationChange}
                showSalesLocation={true}
                salesLocationOptions={salesLocations}
                selectedLineItemStatus={lineItemStatus}
                onLineItemStatusChange={handleLineItemStatusChange}
                showLineItemsFiler={true}
                sortByLatestMessage={sortByLatestMessage}
                onSortByLatestMessageChange={handleSortByLatestMessageChange}
                showSortByLatestMessage={true}
            />
            <div className="flex items-center justify-between gap-2 mb-2 flex-wrap">
                <div className="px-2 py-1 shadow-md rounded-lg bg-gray-300">
                    <span>Total Ads: {totalRecords}</span>
                </div>
                <div className="flex items-center gap-2">
                    <button
                        type="button"
                        className="px-3 py-2 rounded-md bg-sky-600 text-white font-medium disabled:opacity-50"
                        disabled={csvExporting || !(processedData?.length > 0)}
                        onClick={handleDownloadCsv}
                    >
                        {csvExporting ? "Preparing..." : "Download CSV"}
                    </button>
                    <CSVLink
                        data={csvExportData}
                        headers={csvHeaders}
                        filename={`all_ads_${dateRange?.startDate || "start"}_${dateRange?.endDate || "end"}.csv`}
                        ref={csvLinkRef}
                        className="hidden"
                    />
                </div>
            </div>
            <div className='flex flex-col items-start justify-center gap-2'>
                <AdTable
                    data={processedData}
                    columns={allAdsColumns}
                    loading={loading}
                    hasMore={hasMore}
                    onLoadMore={handleLoadMore}
                    designers={designers}
                    showActionsMenu={showActionsMenu}
                    modal={modal}
                    drawer={drawer}
                    expandedVersionsRow={expandedVersionsRow}
                    actionHandlers={actionHandlers}
                    renderCell={renderCell}
                    getModalAlt={getModalAlt}
                    closeExpandedRows={closeExpandedRows}
                    handleDesignerChange={(creativeId, designerId, designerName, creativeName) => handleDesignerChange(creativeId, designerId, designerName, creativeName, handleRefresh)}
                    handleGoToLive={handleGoToLive}
                    fetchContent={fetchContent}
                />
            </div>
        </div>
    );
};

export default AllAds;